<template>
  <v-app>
    <v-toolbar
      height="80"
      fixed
      app
      flat
      :style="{backgroundColor: visible ? '#fafafa' : 'transparent'}"
    >
      <router-link to="/">
        <img
          src="@/assets/Pos/weserve-logo.png"
          alt="weserve-logo"
          width="200px"
          style="cursor:pointer;margin-top:8px;"
        />
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn flat v-scroll-to="'#section2'">{{$t('toolbar.link1')}}</v-btn>
        <v-btn flat v-scroll-to="'footer'">{{$t('toolbar.link2')}}</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-spacer class="hidden-xs-only"></v-spacer>
      <v-spacer class="hidden-xs-only"></v-spacer>
      <v-spacer class="hidden-xs-only"></v-spacer>
      <v-spacer class="hidden-xs-only"></v-spacer>
      <TheLanguageSwitcher />
    </v-toolbar>

    <v-content>
      <!-- <newLandingPage/> -->
      <newLandingPage2 />
      <footerLandingPage />
    </v-content>
  </v-app>
</template>

<script>
import newLandingPage from "@/components/front-web/NewLandingPage";
import newLandingPage2 from "@/components/front-web/NewLandingPage2";
import footerLandingPage from "@/components/front-web/FooterLanding";
import TheLanguageSwitcher from "@/components/Plugins/TheLanguageSwitcher";
export default {
  components: {
    newLandingPage,
    newLandingPage2,
    footerLandingPage,
    TheLanguageSwitcher
  },
  data() {
    return {
      visibleoffset: 20,
      visible: false
    };
  },
  methods: {
    /**
     @return {void}
        */
    catchScroll() {
      this.visible = window.pageYOffset > parseInt(this.visibleoffset);
    },
    /**
     @return {void}
        */
    backToTop() {
      window.smoothscroll();
    }
  },
  mounted() {
    window.smoothscroll = () => {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener("scroll", this.catchScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.catchScroll);
  }
};
</script>